import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { Card, Col, Row } from 'reactstrap';
import { MENUITEMS } from '../../constant/menu';
import { sidebarRoleManagement } from '../../utils/UserManagement';
import useFormatMessage from '../../utils/useFormatMessage';

export default function MenuCards() {
    const [selectedMenuItem, setSelectedMenuItem] = useState(null)
    const [currentMenuPath, setCurrentMenuPath] = useState([])
    const { t } = useFormatMessage();
    const renderIcon = (icon) => {

        // FontAwesome icon objesi kontrolü
        if (icon && typeof icon === 'object' && icon.iconName && icon.prefix) {
            return <FontAwesomeIcon icon={icon} />;
        }

        // React-feather icon kontrolü (object olarak gelir ve displayName özelliği vardır)
        if (icon && typeof icon === 'object' && icon.displayName && !icon.iconName) {
            return React.createElement(icon);
        }

        // React component kontrolü (customIcons için function olarak gelir)
        if (typeof icon === 'function') {
            return React.createElement(icon);
        }

        // String olarak icon class kontrolü (eski FA icon'ları için)
        if (typeof icon === 'string') {
            return <i className={icon}></i>;
        }

        // Diğer durumlar için null
        return null;
    };

    const handleBreadcrumbClick = (index) => {
        if (index === -1) {
            // Ana menüye dön
            setSelectedMenuItem(null);
            setCurrentMenuPath([]);
        } else {
            // Belirli bir seviyeye dön
            const newPath = currentMenuPath.slice(0, index + 1);
            setCurrentMenuPath(newPath);
            setSelectedMenuItem(newPath[newPath.length - 1]);
        }
    };

    // Menü kartlarını oluşturan fonksiyon
    const renderMenuCards = () => {
        // Kullanıcının yetkisi olan menü öğelerini filtrele
        const accessibleMenuItems = MENUITEMS.filter(item => {
            return sidebarRoleManagement(item.permissions);
        });

        const handleSubMenuClick = (menuItem) => {
            const newPath = [...currentMenuPath, menuItem];
            setSelectedMenuItem(menuItem);
            setCurrentMenuPath(newPath);
        };

        // Icon'u güvenli bir şekilde render eden yardımcı fonksiyon
        // Şu anda gösterilecek menü öğelerini belirle
        let itemsToShow = accessibleMenuItems;
        if (selectedMenuItem && selectedMenuItem.children) {
            itemsToShow = selectedMenuItem.children.filter(item => {
                return sidebarRoleManagement(item.permissions);
            });
        }

        return (
            <>
                <style>
                    {`
                    .menu-card {
                        transition: all 0.3s ease;
                        border: 1px solid #e2e8f0;
                        box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
                    }
                    .menu-card:hover {
                        transform: translateY(-4px);
                        box-shadow: 0 10px 25px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
                        border-color: #4A6DF2;
                    }
                    `}
                </style>

                <Row className="mb-4">
                    {itemsToShow.length === 0 ? (
                        <Col sm="12">
                            <div style={{
                                textAlign: "center",
                                padding: "40px",
                                color: "#718096",
                                fontSize: "16px"
                            }}>
                                Erişim yetkiniz olan menü öğesi bulunamadı.
                            </div>
                        </Col>
                    ) : (
                        itemsToShow.map((menuItem, index) => {
                            // Eğer menü öğesinin sadece 1 tane sub'ı varsa, direkt children'ları göster
                            if (menuItem.children && menuItem.children.length === 1) {
                                const subItem = menuItem.children[0];
                                if (subItem.children) {
                                    return (
                                        <Col key={index} xl="3" lg="4" md="6" sm="12" className="mb-3">
                                            <Card className="menu-card" style={{
                                                height: "200px",
                                                cursor: "pointer"
                                            }}
                                                onClick={() => window.location.href = subItem.children[0]?.path || '#'}>
                                                <div className="card-body text-center d-flex flex-column justify-content-center align-items-center">
                                                    <div style={{ fontSize: "32px", marginBottom: "16px", color: "#4A6DF2" }}>
                                                        {renderIcon(menuItem.icon)}
                                                    </div>
                                                    <h5 style={{
                                                        fontSize: "18px",
                                                        fontWeight: "600",
                                                        color: "#2d3748",
                                                        marginBottom: "8px"
                                                    }}>
                                                        {t(menuItem.title)}
                                                    </h5>
                                                    <p style={{
                                                        fontSize: "14px",
                                                        color: "#718096",
                                                        margin: 0
                                                    }}>
                                                        {t(subItem.title)}
                                                    </p>
                                                </div>
                                            </Card>
                                        </Col>
                                    );
                                }
                            }

                            // Eğer menü öğesinin 2 veya daha fazla sub'ı varsa, sub'ları göster
                            if (menuItem.children && menuItem.children.length > 1) {
                                return (
                                    <Col key={index} xl="3" lg="4" md="6" sm="12" className="mb-3">
                                        <Card className="menu-card" style={{
                                            height: "200px",
                                            cursor: "pointer"
                                        }}
                                            onClick={() => handleSubMenuClick(menuItem)}>
                                            <div className="card-body text-center d-flex flex-column justify-content-center align-items-center">
                                                <div style={{ fontSize: "32px", marginBottom: "16px", color: "#4A6DF2" }}>
                                                    {renderIcon(menuItem.icon)}
                                                </div>
                                                <h5 style={{
                                                    fontSize: "18px",
                                                    fontWeight: "600",
                                                    color: "#2d3748",
                                                    marginBottom: "8px"
                                                }}>
                                                    {t(menuItem.title)}
                                                </h5>
                                                <p style={{
                                                    fontSize: "14px",
                                                    color: "#718096",
                                                    margin: 0
                                                }}>
                                                    {menuItem.children.length} alt menü
                                                </p>
                                            </div>
                                        </Card>
                                    </Col>
                                );
                            }

                            // Direkt link olan menü öğeleri
                            if (menuItem.type === 'link') {
                                return (
                                    <Col key={index} xl="3" lg="4" md="6" sm="12" className="mb-3">
                                        <Card className="menu-card" style={{
                                            height: "200px",
                                            cursor: "pointer"
                                        }}
                                            onClick={() => window.location.href = menuItem.path}>
                                            <div className="card-body text-center d-flex flex-column justify-content-center align-items-center">
                                                <div style={{ fontSize: "32px", marginBottom: "16px", color: "#4A6DF2" }}>
                                                    {renderIcon(menuItem.icon)}
                                                </div>
                                                <h5 style={{
                                                    fontSize: "18px",
                                                    fontWeight: "600",
                                                    color: "#2d3748",
                                                    marginBottom: "8px"
                                                }}>
                                                    {t(menuItem.title)}
                                                </h5>
                                            </div>
                                        </Card>
                                    </Col>
                                );
                            }

                            return null;
                        })
                    )}
                </Row>
            </>
        );
    };

    return (
        <>
            <Row>
                <Col sm="12">
                    {/* <Breadcrumb {...breadcrumbProps} /> */}
                </Col>
            </Row>

            {/* Breadcrumb Navigation */}
            <Row className="mb-3">
                <Col sm="12">
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        padding: '12px 16px',

                    }}>
                        <span
                            style={{
                                color: currentMenuPath.length === 0 ? '#2d3748' : '#4A6DF2',
                                cursor: currentMenuPath.length === 0 ? 'default' : 'pointer',
                                fontWeight: currentMenuPath.length === 0 ? '600' : '500',
                                fontSize: '17px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px'
                            }}
                            onClick={() => handleBreadcrumbClick(-1)}
                        >
                            <i className="fa fa-home" style={{ fontSize: "17px" }}></i>
                            Ana Menü
                        </span>
                        {currentMenuPath.map((item, index) => (
                            <React.Fragment key={index}>
                                <span style={{ color: '#cbd5e0', fontSize: '17px' }}>/</span>
                                <span
                                    style={{
                                        color: index === currentMenuPath.length - 1 ? '#2d3748' : '#4A6DF2',
                                        cursor: index === currentMenuPath.length - 1 ? 'default' : 'pointer',
                                        fontWeight: index === currentMenuPath.length - 1 ? '600' : '500',
                                        fontSize: '17px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px'
                                    }}
                                    onClick={() => handleBreadcrumbClick(index)}
                                >
                                    {/*   <div style={{ fontSize: "17px", display: 'flex', alignItems: 'center' }}>
                                        {renderIcon(item.icon)}
                                    </div>*/}
                                    {t(item.title)}
                                </span>
                            </React.Fragment>
                        ))}
                    </div>
                </Col>
            </Row>

            {renderMenuCards()}
        </>
    )
}
